import React from "react";
import { Link } from "react-router-dom";
import BlogHeader from "./BlogHeader";
import BlogFooter from "./BlogFooter";
import "./Blog.css";

function BlogPostSerious() {
  return (
    <div className="blog-wrap">
      <BlogHeader />
      <div className="blog-post-wrap">

        {/* Top bar */}
        <div className="blog-topbar">
          📱 현장통으로 TBM·안전점검·위험성평가를 현장에서 바로 기록
          <a href="/#contact">무료체험 문의</a>
        </div>

        {/* Post header */}
        <div className="blog-post-header">
          <div className="blog-breadcrumb">
            <a href="/">현장통</a> › <Link to="/blog">현장가이드</Link> › <span>법규 가이드</span>
          </div>
          <h1>중대재해처벌법 건설사 실무 대응 가이드 [2026년]</h1>
          <div className="blog-post-meta">
            <span className="meta-tag">법규 가이드</span>
            <span>2026.03.23</span>
            <span>읽기 8분</span>
          </div>
        </div>

        {/* Hero */}
        <div className="blog-hero-img">
          <div className="blog-hero-inner">
            <h2>중대재해처벌법<br />건설사 실무 대응 가이드</h2>
            <p>2026년 최신 판례 반영 | 경영자 9대 의무 체크리스트</p>
            <div className="blog-hero-badges">
              <span className="blog-hero-badge">📋 9대 의무</span>
              <span className="blog-hero-badge">⚖️ 최신 판례</span>
              <span className="blog-hero-badge">✅ 체크리스트</span>
            </div>
          </div>
        </div>

        {/* Article */}
        <article className="blog-article">

          <p>건설업 안전관리자의 업무 중 가장 부담스러운 것이 무엇이냐고 물으면, 열에 아홉은 <strong>"중대재해처벌법 대응"</strong>이라고 답합니다.</p>
          <p>법 시행 4년차에 접어들었지만, 여전히 현장에서는 <strong>"구체적으로 뭘 어떻게 해야 하는지"</strong> 모호하다는 목소리가 많습니다. 특히 건설사 경영진부터 현장 안전관리자까지, 각자의 역할에서 무엇을 준비해야 하는지 명확하게 정리된 자료가 부족합니다.</p>
          <p>이 글에서는 <strong>중대재해처벌법의 핵심 의무를 실무 관점에서 정리</strong>하고, 건설사가 지금 당장 할 수 있는 구체적인 대응 방법을 안내합니다.</p>

          {/* Section 1 */}
          <h2>중대재해처벌법, 건설사에 적용되는 핵심 조항</h2>
          <p>중대재해처벌법은 크게 <strong>경영책임자의 안전보건 확보의무</strong>(제4조)와 <strong>안전보건관리체제 구축 의무</strong>(제5조)를 규정하고 있습니다.</p>

          <div className="hl-box">
            <div className="hl-box-title">📌 건설사에 특히 중요한 조항</div>
            <p><strong>제4조 1항 1호</strong> — 재해예방에 필요한 인력 및 예산 등 안전보건관리체계의 구축 및 이행에 관한 조치</p>
            <p><strong>제4조 1항 2호</strong> — 재해 발생 시 재발방지 대책의 수립 및 이행에 관한 조치</p>
            <p><strong>제4조 1항 3호</strong> — 중앙행정기관·지방자치단체가 개선, 시정 등을 명한 사항의 이행</p>
            <p><strong>제4조 1항 4호</strong> — 안전·보건 관계 법령에 따른 의무이행에 필요한 관리상의 조치</p>
            <p><strong>제5조</strong> — 도급, 용역, 위탁 등 관계에서의 안전 및 보건 확보의무 (별도 조항)</p>
          </div>

          <div className="hl-box warning">
            <div className="hl-box-title">⚠️ 핵심 포인트</div>
            <p>법원은 사고 발생 시 경영자가 안전보건 확보의무를 이행했는지를 <strong>문서와 기록</strong>으로 판단합니다. 말로만 "했다"는 통하지 않습니다.</p>
          </div>

          {/* Section 2 */}
          <h2>경영책임자가 반드시 이행해야 할 9가지 의무 (시행령 제4조)</h2>
          <p>중대재해처벌법 시행령 제4조는 안전보건관리체계 구축과 관련하여 경영책임자가 이행해야 할 의무를 <strong>9가지</strong>로 규정하고 있습니다. 참고로 2024년 1월 27일부터 상시근로자 5인 이상 사업장에도 전면 확대 적용되었습니다.</p>

          {[
            { num: 1, title: "안전보건 목표와 경영방침 설정", desc: "문서화하고 전 직원에게 공유해야 합니다. 대표이사 서명이 포함된 경영방침 문서를 작성하고 전 현장에 게시해야 합니다." },
            { num: 2, title: "안전보건 전담 조직 구성", desc: "전문인력을 배치하고 권한과 예산을 부여해야 합니다. 안전보건관리책임자를 선임하고 고용부에 신고해야 합니다." },
            { num: 3, title: "유해·위험요인 확인 및 개선", desc: "위험성평가를 정기적으로(최소 월 1회) 실시하고, 결과를 기록하고, 개선 조치까지 이어져야 합니다." },
            { num: 4, title: "안전보건 예산 편성 및 집행", desc: "별도 예산을 편성하고 계획대로 집행한 근거를 문서화해야 합니다." },
            { num: 5, title: "안전보건관리 책임자 이행 점검", desc: "경영책임자가 반기 1회 이상 안전보건 이행 상황을 직접 점검하고 기록해야 합니다." },
            { num: 6, title: "종사자 의견 청취 절차 마련", desc: "종사자가 안전 관련 의견을 제출할 수 있는 절차를 마련하고, 조치 결과를 기록해야 합니다." },
            { num: 7, title: "안전보건 교육 실시", desc: "교육 계획을 수립하고 실시 기록을 남겨야 합니다. 교육 내용, 참석자, 일시가 구체적으로 기록되어야 합니다." },
            { num: 8, title: "급박한 위험 시 작업 중지", desc: "현장 관리자에게 작업 중지 권한을 부여하고, 작업 중지 및 재개 절차를 마련해야 합니다." },
            { num: 9, title: "도급·용역·위탁 시 안전 확보 조치", desc: "협력업체 선정 시 안전 능력 평가 기준을 마련하고, 정기적으로 안전관리 실태를 점검해야 합니다." },
          ].map((item) => (
            <div className="key-point" key={item.num}>
              <div className="key-point-header">
                <div className="key-point-num">{item.num}</div>
                <div className="key-point-title">{item.title}</div>
              </div>
              <div className="key-point-desc">{item.desc}</div>
            </div>
          ))}

          <div className="hl-box danger">
            <div className="hl-box-title">⚠️ 실무 포인트</div>
            <p>이 9가지를 "했다"고 말하는 것이 아니라, <strong>"했다는 기록"</strong>이 있어야 합니다. 감사 시 구두 설명은 증거로 인정되지 않습니다.</p>
          </div>

          {/* Inline CTA */}
          <div className="inline-cta">
            <h3>📋 우리 회사 중대재해처벌법 대응 수준은?</h3>
            <p>현장통으로 안전관리 기록을 체계화하고 대응 수준을 점검해보세요</p>
            <a href="/#contact" className="inline-cta-btn">현장통 무료체험 문의하기 →</a>
          </div>

          {/* Section 3 */}
          <h2>최근 판례와 실무 전문가가 말하는 "면책의 기준"</h2>
          <p>최근 하급심에서 경영책임자등의 해석에 관한 판결이 잇따르고 있습니다. 수원지방법원 여주지원은 2025년 12월 19일 선고(2024고단1264)에서, 안전보건업무책임자가 선임되어 있는 경우 사업총괄책임자는 경영책임자등에 해당하지 않는다고 판시하여 면책을 인정한 바 있습니다. <small>(출처: 법률신문)</small></p>
          <p>이러한 판결 흐름과 실무 전문가들의 분석을 종합하면, 면책 여부를 가르는 기준이 보입니다.</p>

          <div className="compare-grid">
            <div className="compare-card good">
              <h4>🟢 면책이 인정된 사례</h4>
              <p>안전보건관리체제가 <strong>문서로 구축</strong>되어 있었고, 위험성평가를 <strong>정기적으로 실시</strong>하면서 기록이 남아 있었습니다.</p>
              <p>사고가 발생한 부분에 대해서도 <strong>사전 조치 기록</strong>이 존재했고, 종사자에게 안전교육을 실시한 <strong>증빙</strong>이 확인되었습니다.</p>
              <p>체제를 만들었을 뿐 아니라 <strong>실제로 작동시킨 흔적</strong>이 곳곳에 남아 있었습니다.</p>
            </div>
            <div className="compare-card bad">
              <h4>🔴 면책이 부정된 사례</h4>
              <p>안전보건관리체제가 있긴 했지만 <strong>형식적</strong>이어서 실제 작동 증거가 없었습니다.</p>
              <p>위험성평가도 <strong>최초 1회만</strong> 실시하고 이후 갱신되지 않았고, 위험이 반복 보고되었는데도 <strong>조치 기록이 없었습니다.</strong></p>
              <p>교육은 <strong>서명부만</strong> 남아 있을 뿐 실질적인 교육 내용 증빙이 없었습니다.</p>
            </div>
          </div>

          <div className="hl-box success">
            <div className="hl-box-title">💡 핵심 교훈</div>
            <p>"체제를 만들었느냐"가 아니라 <strong>"체제가 실제로 작동했느냐"</strong>를 기록으로 증명해야 합니다.</p>
          </div>

          {/* Section 4 */}
          <h2>건설사 규모별 실무 대응 로드맵</h2>

          <div className="info-cards">
            <div className="info-card">
              <div className="info-card-icon">🏢</div>
              <h4>대형 건설사 (현장 10개 이상)</h4>
              <p>1. 전사 안전보건관리체제 문서화<br />2. 전 현장 위험성평가 표준화<br />3. 실시간 모니터링 체계 구축<br />4. 정기 점검, 기록 자동화</p>
            </div>
            <div className="info-card">
              <div className="info-card-icon">🏗️</div>
              <h4>중소 건설사 (현장 1~10개)</h4>
              <p>1. 경영방침 선언, 게시<br />2. 현장별 위험성평가 월 1회<br />3. 안전교육 실시 기록 관리<br />4. TBM 기록 체계화</p>
            </div>
          </div>

          <h3>규모와 관계없이 반드시 갖춰야 할 3가지</h3>
          <table>
            <thead>
              <tr>
                <th>순위</th>
                <th>필수 항목</th>
                <th>최소 기준</th>
              </tr>
            </thead>
            <tbody>
              <tr><td><strong>1</strong></td><td>위험성평가 기록</td><td>최소 월 1회, 변경 시 수시</td></tr>
              <tr><td><strong>2</strong></td><td>안전교육 실시 증빙</td><td>교육 내용, 참석자, 일시</td></tr>
              <tr><td><strong>3</strong></td><td>안전조치 이행 기록</td><td>위험 발견 → 조치 → 확인 전 과정</td></tr>
            </tbody>
          </table>

          {/* Section 5 */}
          <h2>기록 관리, 현실적으로 어떻게 할 것인가</h2>
          <p>솔직히 말하면, 위 모든 기록을 <strong>수기로 관리하는 것은 현실적으로 어렵습니다.</strong></p>
          <p>현장소장 1명이 관리해야 할 법정 서류만 <strong>수십 종</strong>에 달합니다. 여기에 TBM 일지, 안전점검 기록, 교육 일지까지 더하면, 하루 업무의 상당 부분이 서류 작성에 소모됩니다.</p>
          <p>고용노동부 발표에 따르면, 2025년 3분기 누적 건설업 사고사망자는 <strong>210명</strong>으로 전년 동기 대비 7명(3.4%) 증가했습니다. 특히 공사금액 5억 미만 소규모 현장에서 전년 대비 <strong>19명이 증가</strong>한 것으로 나타났는데, 이는 안전관리 체계가 제대로 갖춰지지 않은 현장일수록 위험하다는 것을 보여줍니다. <small>(출처: 고용노동부 보도자료 2025.11.25)</small></p>

          <div className="info-cards">
            <div className="info-card">
              <div className="info-card-icon">📋</div>
              <h4>방법 1: 엑셀/구글시트</h4>
              <p><strong>장점:</strong> 비용 없음, 익숙함<br /><strong>단점:</strong> 현장별 취합 어려움, 누락 위험, 실시간 현황 파악 불가</p>
            </div>
            <div className="info-card highlight">
              <div className="info-card-icon">📱</div>
              <h4>방법 2: 안전관리 전용 앱</h4>
              <p><strong>장점:</strong> 현장에서 즉시 기록, 자동 취합, 법정 서류 자동 생성<br /><strong>단점:</strong> 도입 비용, 현장 적응 기간</p>
            </div>
          </div>

          <p>현장통 같은 안전관리 앱을 활용하면, TBM 기록부터 안전점검, 위험성평가까지 현장에서 스마트폰으로 바로 기록하고, 본사에서 실시간으로 확인할 수 있습니다. 특히 법적 증빙에 필요한 <strong>일시, 장소, 참여자, 조치 내용</strong>이 자동으로 기록됩니다.</p>

          {/* Section 6 */}
          <h2>지금 당장 시작할 수 있는 체크리스트</h2>
          <p>오늘부터 바로 할 수 있는 <strong>최소 행동 목록</strong>입니다.</p>

          <div className="checklist-list">
            {[
              "안전보건 경영방침 1장 문서 작성, 현장 게시",
              "이번 달 위험성평가 실시, 기록 보관",
              "최근 3개월 안전교육 실시 기록 확인 (누락분 보완)",
              "종사자 의견 청취 절차 마련 (건의함, 설문 등)",
              "안전보건 예산 편성 근거 문서 작성",
              "협력업체 안전관리 평가 기준 문서화",
            ].map((item, i) => (
              <div className="checklist-item" key={i}>
                <div className="checklist-box"></div>
                <span>{item}</span>
              </div>
            ))}
          </div>

          {/* Section 7 */}
          <h2>마무리</h2>
          <p>중대재해처벌법 대응의 핵심은 결국 <strong>"기록"</strong>입니다.</p>
          <p>체제를 만들고, 실행하고, 기록하고, 개선하는 <strong>PDCA 사이클</strong>을 문서로 증명할 수 있다면, 법적 리스크를 크게 줄일 수 있습니다. 반대로, 아무리 안전관리를 잘 하고 있어도 기록이 없으면 법적으로는 "하지 않은 것"과 같습니다.</p>
          <p>오늘 소개한 체크리스트부터 하나씩 시작해보세요.</p>

          {/* Bottom CTA */}
          <div className="bottom-cta">
            <div className="bottom-cta-grid">
              <div className="bottom-cta-card download">
                <div className="cta-icon">📖</div>
                <h4>현장가이드 더 보기</h4>
                <p>건설현장 운영·안전·법규 실무 자료를<br />현장가이드에서 확인하세요</p>
                <Link to="/blog">현장가이드 바로가기 →</Link>
              </div>
              <div className="bottom-cta-card trial">
                <div className="cta-icon">📱</div>
                <h4>현장통 무료 체험 문의</h4>
                <p>TBM, 안전점검, 위험성평가를<br />스마트폰으로 바로 기록하세요</p>
                <a href="/#contact">무료체험 문의하기 →</a>
              </div>
            </div>
          </div>

          {/* Tags */}
          <div className="blog-tags">
            {["#중대재해처벌법", "#건설사안전관리", "#안전보건확보의무", "#경영자의무", "#안전보건관리체제", "#위험성평가", "#현장통", "#건설안전앱", "#산업안전보건법", "#안전관리자"].map((tag) => (
              <span key={tag}>{tag}</span>
            ))}
          </div>

          {/* Related */}
          <div className="blog-related">
            <h3>관련 콘텐츠</h3>
            <div className="related-grid">
              {[
                { to: "/blog/safety-manager-paperwork", tag: "현장 운영", title: "안전관리자가 서류에 치이는 진짜 이유 — 그리고 하루를 되찾는 법" },
                { to: "/blog/exemption-one-difference", tag: "경영자 가이드", title: "면책된 회사와 안 된 회사, 딱 하나의 차이" },
                { to: "/blog/executive-punishment-conditions", tag: "경영자 가이드", title: "사고 났을 때 대표이사가 처벌받는 조건 3가지" },
              ].map((item) => (
                <Link className="related-card" to={item.to} key={item.to}>
                  <div className="related-card-tag">{item.tag}</div>
                  <div className="related-card-title">{item.title}</div>
                </Link>
              ))}
            </div>
          </div>

        </article>

        {/* Footer */}
        <BlogFooter />

      </div>
    </div>
  );
}

export default BlogPostSerious;
